import React,{useContext,useEffect,useState} from 'react'
import moment from 'moment'
import CommentsContext  from '../contexts/CommentsContext'
import Comment from './Comment'
import ButtonRow from './ButtonRow'

const Comments = ({posts,users,loggedInUserId,isAdmin}) => {

    const {comments,saveHandler,deleteHandler} = useContext(CommentsContext)
    const [commentsForPosts,setCommentsForPosts] = useState([])
    const [postId,setPostId] = useState(0)

    useEffect( () => {
        setCommentsForPosts( comments.filter( comment => {
            for (const key in posts) {
              const ev = posts[key];
              if( comment.post === ev.id )
                return true;
            }
            return false;
          }) )
    }, [comments,posts,setCommentsForPosts])

    useEffect( () => {
        
        for (const key in posts) {
            if (posts.hasOwnProperty(key)) {
                const post = posts[key];
                if( post.id !== 0 ){
                    setPostId( post.id )
                    return;
                }
            }
        }
          
    },[posts,setPostId])

    const buttons = [
        {
            style: 'spacer'
        },
        {
            style: 'spacer'
        },
        {
            style: 'spacer'
        },
        {
            style: 'light btn-sm',
            label: 'Add Note',
            action: () => {
                setCommentsForPosts(
                    [...commentsForPosts,
                        {
                            id: 0,
                            content: '',
                            author: loggedInUserId,
                            post: postId

                        }
                    ]
                )
            }
        }
    ]

    const commentsElements = commentsForPosts.map( c => {
    
        const userMatches = users.filter( u => u.id === c.author )
        const author = userMatches.length > 0 ? userMatches[0].name : ''
        const authorId = userMatches.length > 0 ? userMatches[0].id : ''
        const formattedDate = c.date ?  moment(c.date).calendar(null, {
            sameElse: 'MMM D YYYY H:mm'
        }) : 'New'

        return(
            <Comment comment={{...c,author_name:author,formatted_date:formattedDate}} onSave={saveHandler} onDelete={deleteHandler} canEdit={authorId === loggedInUserId || isAdmin}/>
        );
    })

    const showButtons = commentsForPosts.length === 0 || commentsForPosts[commentsForPosts.length-1].id !== 0

    return(
    <ul>
        {commentsElements}
        {showButtons ?  <ButtonRow buttons={buttons}/> : ''}
    </ul>)
}
export default Comments;    